(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page__main-coa-reports"]) return;
  try {
    
// coa tabs
if (jQuery('.coa-tab-title').length) {
  var tab_titles = jQuery('.coa-tab-title');
  jQuery(tab_titles[0]).parent().parent().before('<ul class="tabs"></ul>');
  jQuery(tab_titles).each(function(index) {
    var title = jQuery(this).text();
    if (index > 0 ) {
      jQuery('ul.tabs').append('<li><a href="#tab-' + index + '">' + title + '</a></li>');
    } else {      
      jQuery('ul.tabs').append('<li><a href="#tab-' + index + '" class="is-active">' + title + '</a></li>');
    }
    var titleSection = jQuery(this).parent().parent();
    var endSection = titleSection.next('.block__custom-html');
    if (index > 0 ) {
      jQuery(titleSection).nextUntil(".block__custom-html", ".block__image-with-overlay").wrapAll('<li id="tab-' + index + '"></li>');
    } else {
      jQuery(titleSection).nextUntil(".block__custom-html", ".block__image-with-overlay").wrapAll('<li id="tab-' + index + '" class="is-active"></li>');
    }
  });
  jQuery('ul.tabs').nextUntil('.block__custom-html:last-child').wrapAll('<ul class="tabs-content"></ul>');

  var $tabs = $('.tabs li a');
  $tabs.on('click', function (el) {
    el.preventDefault(); // toggle active tab

    $tabs.removeClass('is-active active');
    $(this).addClass('is-active');
    var $tabIndex = $(this).attr("href");
    var $tabContent = $(this).parents('.tabs').next('.tabs-content'); // toggle corresponding tab content

    $tabContent.children('li').removeClass('is-active active');
    $tabContent.children('li' + $tabIndex).addClass('is-active').show().css({
      'display': 'block'
    }).siblings().hide().removeClass('is-active');
  });

}

  } catch(e) { console.error(e); }
})();
})();
